import gql from "graphql-tag";
import { productSetQueryReturnFields } from "./getProductSet";

export const GET_PRODUCT_SETS = gql`query getProductSets {
    getProductSets {
        ${productSetQueryReturnFields}
    }
}`;
